
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(.5 .5)","fill":"none","fill-rule":"evenodd"}},[_c('circle',{attrs:{"stroke":"#007AFF","cx":"6.5","cy":"6.5","r":"6.5"}}),_c('g',{attrs:{"transform":"translate(4.75 3)"}},[_c('circle',{attrs:{"fill":"#007AFF","fill-rule":"nonzero","cx":"1.75","cy":"6.781","r":"1"}}),_c('path',{attrs:{"d":"M1.75 4.554c.037.002-.037-1.054 0-1.054A1.75 1.75 0 100 1.75","stroke":"#007AFF","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])])])
          )
        }
      }
    